<template>
  <div id="app">
    <div id="rootContainer">
      <div id="mainContainer">
        <LanguageDropdown />
        <router-view @rewardData="getRewardData" @Details="getRewardDetails"  :rewardDetails="rewardDetails" :rewardData="rewardData"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageDropdown from "./components/language-dropdown.vue";

export default {
  name: 'app',
  components: {LanguageDropdown},
  data: function () {
    return {
      rewardData: {},
      rewardDetails: {},
    }
  },
  methods: {
    getRewardData(data) {
      this.rewardData = data
    },
    getRewardDetails(details) {
      this.rewardDetails = details
    }
  }
}
</script>



<style>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0,0,0,0);
  border: 0;
}
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  position:relative;
}

#rootContainer {
  display: flex;
  justify-content: center;
}

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html {
  font-size: 14px;
}
body {
  font-family: 'Montserrat', sans-serif;
  font-size:1rem;
  color:#222222;
  padding-bottom: 3rem;
}
p {
  color:#515365;
  line-height: 24px;
}


.container {
  width:90%;
  max-width: 700px;
  margin:0 auto;
  text-align: center;
}
.order-code-val {
  flex: 1;
}
.logo-container {
  margin-bottom: 4rem;
  margin-top: 5rem;
}
h1 {
  margin-top:2rem;
  font-size:2.14rem;
}
form  {
  width: 100%;
  text-align: center;
}
form input {
  width: 400px;
  box-sizing: border-box;
  text-align: center;
  border:solid 1px #D8DBE6;
  max-width: 100%;

}
h2, form input, .fs2 {
  font-size:1.29rem;
}

.separator {
  border-bottom:solid 1px #D8DBE6;
  margin-top: 2rem;
  margin-bottom:2rem;

}
form input, .button, .error-msg, .success-msg {
  border-radius: 4px;
  padding:1.28rem 0;
}
form input {
  padding:14.5px;
}
form input,h1, h2 {
  font-weight: bold;
}
#rcActivationCode::placeholder {
  color:#515365;
  opacity: 1;
  font-weight: bold;
}
.button {
  display:block;
  margin:0 auto;
  background-color:#0042FF;
  font-size:14px;
  color:white;
  border:none;
  cursor: pointer;
}




.button, .error-msg {
  margin-top:1.5rem;
}


/*Langauge dropdown */
.language-dropdown {
  position: absolute;
  right: 0;
}
.lang-btn {
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  background-color: white;
  color: #515365;
  padding: 16px;
  border: none;
  cursor: pointer;
  outline-offset: 4px;
}

.lang-btn-content {
  background-color: #f9f9f9;
  min-width: 200px;
  max-height: 300px;
  overflow: auto;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  z-index: 1;
  padding-left: 0;
  position: absolute;
  top: 28px;
  right: 0;
}

.lang-btn-content li {
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  text-align: left;
  color: #515365;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.lang-btn-content li:focus-visible{
  outline-offset: -1px;
}

.lang-btn-content li:hover, .lang-btn-content li:focus {background-color: #D8DBE6}

.globe-icon {
  position: relative;
  top: 3px;
  left: 12px;
  width: 16px;
  height: 16px;
}

.down-icon {
  position: relative;
  top: 1px;
  left: -8px;
  width: 13px;
  height: 11px;
}

.check-icon {
  opacity: 0;
  fill: #378BFC;
  width: 21px;
  height: 16px;
}

.lang-btn-content svg.selected-lang {opacity: 1}
/*____________*/


.error-msg {
  background-color:#FEF5E6;
  border:solid 1px #E2C38F;
  display: flex;
  align-items: flex-start;
}
.error-msg, .success-msg {

  text-align: left;
  align-items: flex-start;
  padding:37px 0;
  display: none;

}
.error-msg.active, .success-msg.active {
  display: flex;
}
.error-msg img, .success-msg img {
  flex:0 0 auto;
  object-fit: contain;
  padding-left: 25px;
  padding-top:5px;
}

.error-msg p, .success-msg p {
  margin: 0;
  padding:0 1rem 0 1.9rem;
  letter-spacing: 0px;
  line-height: 24px;
  color:#333;
  font-weight: bold;

}

.success-msg img {
  padding-top:0;
}
.success-msg {
  padding:20px 0;
  align-items: center;
  border:solid 1px #C4E8D3;
  background-color:#F1FFEE;
}

.success-msg {
  margin-bottom:3.5rem;
  margin-top: 2rem;
}
h2 {
  margin-top: 2rem;
}
.brand-img {
  max-width: 100%;
}

.details-table {
  border:solid 1px #D8DBE6;
  font-weight: 500;
  text-align: left;
  margin-bottom: 2rem;
  overflow-wrap: break-word;
  word-break: break-word;
}
.details-table .title-txt {
  border-bottom:solid 1px #D8DBE6;
}
.details-table .key {
  font-size:12px;
  margin:0;
  padding-right:50px;
  min-width: 83px;
  box-sizing: border-box;
  font-weight: bold;
  color: #222;
}

.details-table .title-txt p {
  font-size:1rem;
  text-align: left;
  margin:0;
  flex-grow:1;
  padding-right: 1rem;
  word-break: break-word;
}

.details-table p {
  font-weight: bold;
  color: #222;
}

.details-table .title-txt + .x {
  padding-top:24px;
}
.details-table .x:last-child {
  padding-bottom: 24px;
  padding-top: 24px;
}
.details-table .x {
  padding:12px 0;
}
.details-table .x {
  padding-left: 1.5rem;
  padding-right: 1.5rem

}

.details-table span, .details-table h5 {
  font-size:1.15rem;
}

.x {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.button.submit {
  max-width: 400px;
  width: 100%;
  font-weight: bold;
}
button, input {
  font-family: 'Montserrat', sans-serif;
}
.brand-img-thumbnail {
  width:100px;
  flex: 0 0 auto;
}
@media screen and (max-width: 768px) {
  html { font-size: 12px;}
}
@media screen and (max-width:580px) {
  #rootContainer {
    flex-flow: row wrap;
  }
  .title-txt p {
    padding:12px 0;
  }
  .order-code-val {
    padding-right:0;
  }
}
@media screen and (max-width:420px) {
  .details-table .x {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }
  .details-table span, .details-table a {
    width:100%;
  }
  .order-code-val {
    flex:1 0 100%;
  }
}

@font-face {
  font-family: "Montserrat";
  src: local("Montserratt"), url("./../assets/fonts/Montserrat-VariableFont_wght.ttf"),
  format("truetype");
}

</style>
